import { render, staticRenderFns } from "./AdresEkle.vue?vue&type=template&id=23d759c2&scoped=true"
import script from "./AdresEkle.vue?vue&type=script&lang=js"
export * from "./AdresEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d759c2",
  null
  
)

export default component.exports